import Transformer from '@/transformers/transformer'

// const rejectedTransformer = function () {
//   return {

//   }
// } 

const requisitionsTransformer = function ({
  iwarehouseRequisitionSupplyId, quantity, 
}) {
  return {
    id: iwarehouseRequisitionSupplyId,
    amount: quantity
  }
} 

export default class sinisterSMTransformer extends Transformer {
  static fetch() {}

  static send({ rejectedSupplies, requisitionSupplies, requisitionId }) {
    return {
      requisition: [requisitionId],
      supply_refused: rejectedSupplies,
      supplies: requisitionSupplies.length > 0 ? requisitionSupplies.map(requisitionsTransformer) : [] 
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/warehouse/requisitionsToPurchase.js